var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"block":"","color":"primary"},on:{"click":_vm.openImport}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("mdi-file-upload ")]),_c('p',{staticClass:"pa-0 ma-0 pt-1",attrs:{"align":"center"}},[_vm._v(" "+_vm._s(_vm.$t('teacher.import-classList'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }